import React from 'react';
import { useLocation } from 'react-router-dom';
import TopNav from './TopNav';
import AppErrorBoundary from './AppErrorBoundary';

/**
 * The chrome around every route. Shared by App.js and the build-time
 * renderer (src/seo/ssrEntry.jsx) so prerendered pages hydrate onto the
 * exact markup React expects.
 */
export default function AppFrame({ theme, onToggleTheme, children }) {
  const location = useLocation();
  return (
    <div className="app">
      <a className="skip-link" href="#app-content">Skip to content</a>
      <TopNav onToggleTheme={onToggleTheme} theme={theme} />
      <AppErrorBoundary key={location.pathname}>
        <div id="app-content" tabIndex="-1">
          {children}
        </div>
      </AppErrorBoundary>
    </div>
  );
}
